import React from 'react';
import ProspectsTableRow from '../oldcampaign/ProspectsTableRow';

const ProspectsTable = ({ isLoading, prospects, selectedRows, selectAll, onRowSelect, onSelectAll, ...rowHandlers }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left">
        <thead className="bg-slate-50">
          <tr>
            <th className="p-4 w-12">
              <input type="checkbox" checked={selectAll} onChange={onSelectAll} className="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"/>
            </th>
            <th className="p-4 font-semibold text-slate-600 uppercase tracking-wider">Company</th>
            <th className="p-4 font-semibold text-slate-600 uppercase tracking-wider">Representative</th>
            <th className="p-4 font-semibold text-slate-600 uppercase tracking-wider">Campaign Progress</th>
            {/* <th className="p-4 font-semibold text-slate-600 uppercase tracking-wider">Campaign Status</th> */}
            <th className="p-4 font-semibold text-slate-600 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-100">
          {isLoading ? (
             <tr><td colSpan="6" className="text-center p-8 text-slate-500 font-medium">Loading prospects...</td></tr>
          ) : prospects.length > 0 ? (
            prospects.map(prospect => (
              <ProspectsTableRow key={prospect.company_id} prospect={prospect} isSelected={selectedRows[prospect.company_id] || false} onRowSelect={onRowSelect} {...rowHandlers} />
            ))
          ) : (
            <tr><td colSpan="6" className="text-center p-8 text-slate-500 font-medium">No prospects found.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProspectsTable;